import SelectInput from 'components/form/select.js.jsx'
import SliderInput from 'components/form/slider.js.jsx'

export default class MapFilters extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      availableJobAdLocations: props.availableJobAdLocations,
      locationText: props.searchParams.location_text_eq || '',
      location: props.searchParams.location || '',
      region: props.searchParams.region || '',
      latitude: props.searchParams.location_latitude || '',
      longitude: props.searchParams.location_longitude || '',
      distance: props.searchParams.location_distance || '',
      distanceSearchActive: props.distanceSearchActive
    }

    this.locationSelect = React.createRef()
    this.autocompleteInput = React.createRef()
    this.distanceInput = React.createRef()
  }

  componentDidUpdate () {
    if (this.props.maps && this.autocompleteInput.current && !this.autocomplete) {
      this.autocomplete = new this.props.maps.places.Autocomplete(this.autocompleteInput.current, {
        types: ['(regions)']
      })

      this.autocomplete.addListener('place_changed', () => {
        if (this.autocomplete && this.autocomplete.getPlace()) {
          this.__handleRegionAutocompleted(this.autocomplete.getPlace())
        }
      })
    }
  }

  render () {
    return (
      <div className='filters-container'>
        <div className='form-group'>
          <SelectInput
            name='query[location]'
            placeholder={`- ${I18n.t('layouts.search.location')} -`}
            field='location'
            allowClear
            ref={this.locationSelect}
            value={this.state.location}
            select_options={this.state.availableJobAdLocations}
            onSelect={this.__handleLocationSelected.bind(this)}
            onClear={this.__handleLocationSelected.bind(this)}
          />
        </div>
        <div className='location-hint'>{I18n.t('layouts.search.or')}</div>
        <div className='form-group'>
          <div className='input-group'>
            <label className='control-label geolocation-label'>
              <i className='fa-map text-muted' />
            </label>
            <input
              type='text'
              className='form-control prevent-auto-submit'
              name='query[region]'
              ref={this.autocompleteInput}
              id='city-autocomplete'
              defaultValue={this.state.region}
              disabled={this.__isLocationSelected()}
            />
            <div className='input-group-append'>
              <a className='btn-primary' onClick={this.__handleGeolocationQuery.bind(this)}><i className='geolocation-icon' /></a>
            </div>
          </div>
        </div>

        <div className='distance'>
          <div className='form-group'>
            <label className='checkbox'>
              <input
                type='checkbox'
                className='prevent-auto-submit'
                ref={this.distanceInput}
                defaultChecked={!!this.state.distanceSearchActive}
                disabled={!this.__isPositionDefined()}
                onChange={this.__toggleDistance.bind(this)}
              />
              <span className='box' />{I18n.t('layouts.search.search_within_distance')}
            </label>

            {!!this.state.distanceSearchActive &&
              <SliderInput
                name='query[location_distance]'
                placeholder='slider'
                field='location_distance'
                value={this.state.distance}
                step={10}
                onChange={this.__handleSliderChange.bind(this)}
                disabled={!this.state.distanceSearchActive}
                customClass='location-distance-slider mtop15'
              />}
          </div>
        </div>

        <input type='hidden' name='query[location_text_eq]' value={this.state.locationText} />
        <input type='hidden' name='query[location_latitude]' value={this.state.latitude} />
        <input type='hidden' name='query[location_longitude]' value={this.state.longitude} />
      </div>
    )
  }

  __handleGeolocationQuery () {
    if (this.autocompleteInput.current && navigator.geolocation) {
      this.autocompleteInput.current.value = 'Geocoding...'

      navigator.geolocation.getCurrentPosition((position) => {
        const location = { lat: position.coords.latitude, lng: position.coords.longitude }
        const geocoder = new this.props.maps.Geocoder()

        geocoder.geocode({ location }, (results, status) => {
          if (status !== 'OK') {
            $.growlyflash({ msg: 'Unable to find your location.', type: 'danger' })
            return
          }

          const address = results[0].formatted_address

          this.setState({
            locationText: results[0].formatted_address,
            latitude: location.lat,
            longitude: location.lng
          })

          this.props.map.panTo(location)
          this.props.map.setZoom(10)
          this.autocompleteInput.current.value = address
        })
      })
    } else {
      $.growlyflash({ msg: 'Geolocation disabled.', type: 'danger' })
      this.autocompleteInput.current.value = ''
    }
  }

  __handleLocationSelected (event) {
    event.stopPropagation()
    const selector = event.target
    const selectedIndex = selector.selectedIndex
    const selectedOption = this.state.availableJobAdLocations[selectedIndex - 1] || []
    const position = selectedOption[2] || {}

    this.setState({
      locationText: selectedOption[0] || '',
      location: selectedOption[0] || '',
      latitude: parseFloat(position.latitude) || '',
      longitude: parseFloat(position.longitude) || '',
      region: ''
    }, () => {
      this.__submit()
    })
  }

  __handleRegionAutocompleted (place) {
    if (!place.geometry) return
    this.setState({
      region: place.formatted_address || '',
      locationText: place.formatted_address,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
      location: ''
    }, () => {
      this.__submit()
    })
  }

  __handleSliderChange (value) {
    if (value) {
      $(this.distanceInput.current.form).trigger('submit')
    } else {
      this.setState({ distanceSearchActive: false }, () => {
        $(this.distanceInput.current.form).trigger('submit')
      })
    }
  }

  __toggleDistance (e) {
    this.setState({ distanceSearchActive: !!e.target.checked }, () => {
      if (this.state.distanceSearchActive === false) {
        this.__submit()
      }
    })
  }

  __isPositionDefined () {
    const parsedLat = parseFloat(this.state.latitude)
    const parsedLng = parseFloat(this.state.longitude)

    return _.isFinite(parsedLat) && _.isFinite(parsedLng)
  }

  __isLocationSelected () {
    if (this.locationSelect.current) {
      const select = this.locationSelect.current.refs.currentSelect
      if (select?.selectedIndex) {
        return select.selectedIndex > 0
      } else {
        return false
      }
    } else {
      return false
    }
  }

  __submit () {
    if (this.distanceInput.current) {
      $(this.distanceInput.current.form).trigger('submit')
    } else {
      console.warn('Unable to submit location search form.')
    }
  }
}
